import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import usePageTitle from '../hooks/usePageTitle';
import useCanonicalTag from '../hooks/useCanonicalTag';
import useMetaTags from '../hooks/useMetaTags';
import '../styles/fonts.css';

const s = { fontSize: '14px', lineHeight: '1.8', color: '#8b949e' };
const h2 = { fontSize: '17px', fontWeight: 600, color: '#e6edf3', marginBottom: '10px', marginTop: '32px' };

function Donations() {
  const { t } = useTranslation();
  usePageTitle('Support Celeritas');
  useCanonicalTag();
  useMetaTags({ title: 'Support Celeritas | Donations', url: 'https://celeritas.live/donations' });

  return (
    <div style={{ minHeight: '100vh', background: '#1b1f23', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <main style={{ flex: 1, maxWidth: '800px', margin: '0 auto', padding: '48px 24px', color: '#c9d1d9' }}>

        <h1 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '8px', color: '#fff' }}>
          {t('donations.title')}
        </h1>
        <p style={{ fontSize: '13px', color: '#8b949e', marginBottom: '32px' }}>
          {t('donations.subtitle')}
        </p>

        <p style={s}>{t('donations.intro')}</p>

        <h2 style={h2}>{t('donations.whyTitle')}</h2>
        <p style={s}>{t('donations.whyText')}</p>
        <p style={{ ...s, marginTop: '12px' }}>{t('donations.whyText2')}</p>

        <h2 style={h2}>{t('donations.howTitle')}</h2>
        <p style={s}>{t('donations.howText')}</p>

        <div style={{ display: 'flex', gap: '16px', marginTop: '24px', flexWrap: 'wrap' }}>

          {/* Mercado Pago */}
          <a
            href="https://link.mercadopago.com.br/celeritas"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              flex: '1', minWidth: '220px',
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px',
              padding: '24px 20px',
              background: '#21262d', border: '1px solid #30363d', borderRadius: '10px',
              textDecoration: 'none', color: '#fff', transition: 'border-color 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.borderColor = '#009ee3'}
            onMouseLeave={e => e.currentTarget.style.borderColor = '#30363d'}
          >
            <span style={{ fontSize: '18px', fontWeight: 700, color: '#009ee3', letterSpacing: '-0.5px' }}>
              mercado<span style={{ color: '#00b1ea' }}>pago</span>
            </span>
            <span style={{ fontSize: '14px', fontWeight: 600, marginTop: '4px' }}>
              {t('donations.mpBtn')}
            </span>
            <span style={{ fontSize: '12px', color: '#8b949e' }}>
              {t('donations.mpDesc')}
            </span>
          </a>

          {/* Stripe */}
          <a
            href="https://donate.stripe.com/dRm9AM3a1fHL5Qf3byaR200"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              flex: '1', minWidth: '220px',
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px',
              padding: '24px 20px',
              background: '#21262d', border: '1px solid #30363d', borderRadius: '10px',
              textDecoration: 'none', color: '#fff', transition: 'border-color 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.borderColor = '#635bff'}
            onMouseLeave={e => e.currentTarget.style.borderColor = '#30363d'}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/b/ba/Stripe_Logo%2C_revised_2016.svg"
              alt="Stripe"
              style={{ height: '28px', objectFit: 'contain', filter: 'brightness(0) invert(1)' }}
            />
            <span style={{ fontSize: '14px', fontWeight: 600, marginTop: '4px' }}>
              {t('donations.stripeBtn')}
            </span>
            <span style={{ fontSize: '12px', color: '#8b949e' }}>
              {t('donations.stripeDesc')}
            </span>
          </a>

        </div>

        <p style={{ ...s, marginTop: '24px' }}>{t('donations.howText2')}</p>

        <a
          href="https://discord.gg/mR45gCfark"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '8px',
            marginTop: '16px', padding: '10px 20px',
            background: '#5865F2', color: '#fff',
            borderRadius: '6px', textDecoration: 'none',
            fontSize: '14px', fontWeight: 600,
          }}
        >
          <i className="fab fa-discord" />
          {t('donations.discordBtn')}
        </a>

      </main>
      <Footer />
    </div>
  );
}

export default Donations;
